 // 线上接口地址
 let isShareAllow = true;
 let taskName = "";
 let taskId = "";
 let desc = "";
 let taskRang = "";
 let coverPic = "";
 let toolsCode = "";
 let showBack = false;
 let person = {
    userId:""
 }
 export default{
    isShareAllow,
    taskName,
    taskId,
    taskRang,
    coverPic,
    toolsCode,
    person,
    showBack,
    desc
 }
